import React from 'react';
import RoleManagement from 'pages/SuperAdmin/RoleManagement';

/** Roles & Permissions for Reseller Owner (feature: role_permissions). */
const ResellerRoles = () => {
    const firmIdRaw = localStorage.getItem('firmId');
    const firmId = firmIdRaw ? Number(firmIdRaw) : null;

    if (!firmId) {
        return (
            <div style={{ padding: 24, color: '#64748b' }}>
                No firm is linked to this account. Contact platform support.
            </div>
        );
    }

    return (
        <RoleManagement
            firmId={firmId}
            title="Roles & Permissions"
            subtitle="Set what your staff can do in the reseller portal and when they open a client company. Same starter roles for every firm — customize as needed."
        />
    );
};

export default ResellerRoles;
